import { axiosClient } from "../axios";

const baseUrl = "/api/registry/enterprises";

export function create(data) {
  return axiosClient.post(baseUrl, data);
}

export function get(id) {
  return axiosClient.get(`${baseUrl}/${id}`);
}

export function clone(enterpriseId, data) {
  return axiosClient.post(`${baseUrl}/${enterpriseId}/clone`, data);
}

export function update(enterpriseId, data) {
  return axiosClient.put(`${baseUrl}/${enterpriseId}`, data);
}

export function toggle(enterpriseId) {
  return axiosClient.post(`${baseUrl}/${enterpriseId}/toggle`);
}

export function exportCompiledEligibilityTests(enterpriseId) {
  return axiosClient.get(
    `${baseUrl}/${enterpriseId}/compiled-eligibility-tests/export`
  );
}
